<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-file-document-box</v-icon>
              <v-toolbar-title>GL List</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <message :messages="messages"></message>
              <v-layout row wrap>
                <!-- <v-flex xs12 sm6 md6 lg6>
                  <v-autocomplete v-model="form.acctPeriod" :items="acctPeriodList" :label="labels.acctPeriod" data-vv-name="acctPeriod" :data-vv-as="labels.acctPeriod" :error-messages="errors.collect('acctPeriod')"
                    v-validate="'required'" item-text="mthYrEndDate" item-value="acctPerEndDate" ></v-autocomplete>
                </v-flex> -->
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="form.acctPer"
                    :label="labels.acctPeriod"
                    :error-messages="errors.collect('acctPer')"
                    :data-vv-as="labels.acctPeriod"
                    data-vv-name="acctPer"
                    append-icon="mdi-magnify"
                    readonly
                    v-validate="'required'"
                    :loading="submitting"
                    @click:append="showAcctPeriodHelpList = true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-text-field
                    v-model="form.batchNo"
                    :label="labels.batchNo"
                    :error-messages="errors.collect('batchNo')"
                    data-vv-name="batchNo"
                    :data-vv-as="labels.batchNo"
                    v-int-mask="{ intScale: 3 }"
                    type="tel"
                    v-validate="'mask_max_value:9999|mask_min_value:0'"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md6 lg6>
                  <v-radio-group v-model="form.cRpt" row :mandatory="true" @change="doCRpt($event)">
                    <v-radio :label="labels.inward" value="I"></v-radio>
                    <v-radio :label="labels.outward" value="O"></v-radio>
                    <v-radio :label="labels.claims" value="C"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox color="primary" :label="labels.rptParam" v-model="form.rptParam"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 class="pt-3">
                  <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                    {{ labels.export }}
                    <v-icon right dark>mdi-file-export</v-icon>
                  </v-btn>
                  <v-btn-toggle dense mandatory v-model="form.format">
                    <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                      <span>{{ format.label }}</span>
                      <v-icon :color="format.color">{{ format.icon }}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showAcctPeriodHelpList" width="1280px">
      <acct-period-help-list
        @close="showAcctPeriodHelpList = false"
        @assign-acct-period-info="assignAcctPeriod"
        :boolRefresh="showAcctPeriodHelpList"
        :modeNo="modeNo"
      ></acct-period-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
// import clone from 'clone'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import AcctPeriodHelpList from '@/components/core/common/dialog/AcctPeriodHelpList'

export default {
  data() {
    return {
      submitting: false,
      labels: {
        acctPeriod: 'Accounting Period',
        batchNo: 'Batch No.',
        inward: 'Inward Premium',
        outward: 'Outward Premium',
        claims: 'Claims',
        export: 'Export To',
        rptParam: 'Print report runtime parameters'
      },
      form: {
        acctPeriod: undefined,
        acctPer: undefined,
        batchNo: 0,
        cRpt: undefined,
        format: 'PDF',
        rptParam: true
      },
      acctPeriodList: [],
      supportedFormat: [],
      showAcctPeriodHelpList: false,
      modeNo: '3'
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.doCRpt('I')
      this.resetMessages()
      this.getAcctPeriods('3').then((result) => {
        const today = new Date()
        const year = today.getFullYear()
        const month = today.getMonth() + 1
        for (let acctPeriod of this.acctPeriodList) {
          if (acctPeriod.acctPerMth === month && acctPeriod.acctPerYr === year) {
            this.form.acctPeriod = acctPeriod.acctPerEndDate
            this.form.acctPer = acctPeriod.acctPerMth + ' / ' + acctPeriod.acctPerYr
          }
        }
      })
      const apiURI = this.$store.state.reports.custom1Reports.menu.glListInit
      const result = await this.$http.get(apiURI)
      if (result.data) {
        const { data } = result.data
        if (data) {
          this.supportedFormat = data.format
          this.menu = extractMenu(result.data._links)
        }
      }
    },
    assignAcctPeriod(data) {
      this.resetValidator()
      this.resetMessages()
      this.form.acctPeriod = data.acctPerEndDate
      this.form.acctPer = data.acctPerMth + ' / ' + data.acctPerYr
      this.showAcctPeriodHelpList = false
    },
    doCRpt(data) {
      this.form.cRpt = data
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitting = true
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiUrl = this.menu.exportGlList
      if (apiUrl) {
        try {
          this.submitting = true
          await this.$http.post(apiUrl, this.form)
          this.$toast.success('Submitted Successfully.')
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.submitting = false
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportGlList]')
      }
      this.submitting = false
    }
  },
  beforeMount() {
    if (this.$store.state.reports.custom1Reports.init !== 1) {
      this.$store.dispatch('custom1ReportsInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    AcctPeriodHelpList
  }
}
</script>
